module.exports = __webpack_public_path__ + "static/img/new-3.1.ce7fc2db.jpg";